import { createSlice } from '@reduxjs/toolkit';
import BaseError from 'utils/base-error';
// eslint-disable-next-line no-restricted-imports
import { createStrapiMediaUrl, fetchLeadFormThunk } from 'shared/lib';
import { DeliveryArticlePageState } from './state';
import { DeliveryArticlePageActions } from './actions';
import { createDeliveryArticleFromGetDeliveryArticleByUidApiResponse } from '../utils';

const initialState: DeliveryArticlePageState = {
    loaded: false,
    errors: [],
};

export const deliveryArticlePageSlice = createSlice({
    name: 'deliveryArticlePageSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(
            DeliveryArticlePageActions.getDeliveryArticleByUid.fulfilled,
            (state, action) => {
                const response = action.payload;

                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    try {
                        // eslint-disable-next-line max-len
                        state.deliveryArticle = createDeliveryArticleFromGetDeliveryArticleByUidApiResponse(
                            response.data,
                        );
                    } catch (e) {
                        state.errors.push(new BaseError(400, String(e)));
                    }
                }
            },
        );
        builder.addCase(
            fetchLeadFormThunk.fulfilled,
            (state, action) => {
                const response = action.payload;
                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    state.leadFormPdf = response.data.data.commercialOfferFile ? {
                        url: createStrapiMediaUrl(response.data.data.commercialOfferFile.url),
                    } : undefined;

                    state.loaded = true;
                }
                state.loaded = true;
            },
        );
    },
});
